export default {
  Type: "Loại danh mục",
  Name: "Tên danh mục",
  Description: "Ghi chú",
  AddButton: "Thêm mới",
  Detail: {},
  Search: {
    Title: "Danh mục",
  },
};
